export type MarketingOptInPetType = 'dog' | 'cat';

export type MarketingOptInChannels = 'email' | 'sms' | 'whatsapp';

export type MarketingOptInChannelCombination = 'email' | 'email_sms' | 'email_whatsapp';

export type MarketingOptInSource = 'services' | 'post-checkout';

export type MarketingOptInDismissAction = 'click-maybe' | 'close-sheet';

export type MarketingOptInVariationKey =
  | 'cat_email'
  | 'cat_email_sms'
  | 'cat_email_whatsapp'
  | 'dog_email'
  | 'dog_email_sms'
  | 'dog_email_whatsapp';

export type MarketingOptInProps = {
  onRequestClose: () => void;
  petType: MarketingOptInPetType;
  channels: MarketingOptInChannels[];
  marketingOptInSource?: MarketingOptInSource;
  countryCode?: string;
  isOpen?: boolean;
  onOptIn: () => void;
  onDecline: () => void;
  onDismiss: () => void;
};

export enum MarketingOptInPromptVariation {
  CONTACTABILITY_M1 = 'contactability_m1',
  DEFAULT = 'control',
}
